/** Only an https URL is rendered as a link or an in-page preview. */
export function httpsUrlOrNull(url: string | null | undefined): string | null {
  return typeof url === 'string' && /^https:\/\//i.test(url) ? url : null;
}
